import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "New challenge", -1)
const _hoisted_3 = { class: "md:flex justify-between items-center md:mb-10" }
const _hoisted_4 = { class: "flex-1 mb-6 md:mb-0 md:mr-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Who is it about?", -1)
const _hoisted_6 = { class: "flex-1 mb-6 md:mb-0 md:ml-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "What topic(s) does it cover?", -1)
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, "Summarise the current situation and your desired outcome", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode(" Add tags "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-dark font-robotoRegular" }, " (optional) ")
], -1)
const _hoisted_11 = { class: "text-cebai-primary p-0.5 border-2 border-cebai-grey-light rounded-full hover:bg-cebai-grey-lightest transition" }
const _hoisted_12 = {
  key: 0,
  class: "mb-9"
}
const _hoisted_13 = { class: "mt-6 flex justify-between" }
const _hoisted_14 = { class: "flex flex-start items-center mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", null, "Latest challenges", -1)
const _hoisted_16 = {
  key: 1,
  class: "my-6 px-5 py-6 rounded-md bg-cebai-grey-lighter text-base text-cebai-grey-dark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_AutoResizeTextarea = _resolveComponent("AutoResizeTextarea")!
  const _component_ArrowUpIcon = _resolveComponent("ArrowUpIcon")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_ContentBlock = _resolveComponent("ContentBlock")!
  const _component_ContentBlockDivider = _resolveComponent("ContentBlockDivider")!
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!
  const _component_ChallengesList = _resolveComponent("ChallengesList")!
  const _component_GuidedTour = _resolveComponent("GuidedTour")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ContentBlock, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Editorial, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_AppButton, {
            id: "button-example",
            type: "secondary",
            class: _normalizeClass(["transition-all", {
          'opacity-100': _ctx.showTryExampleButton,
          'opacity-0 pointer-events-none': !_ctx.showTryExampleButton,
        }]),
            onClick: _ctx.handleTryExample
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Try an example ")
            ]),
            _: 1
          }, 8, ["class", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Editorial, { class: "w-full sm:w-auto" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_Multiselect, {
              id: "input-subject",
              modelValue: _ctx.inputSubject,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputSubject) = $event)),
              mode: "tags",
              placeholder: "Select 2 maximum",
              max: 2,
              groups: _ctx.isAuthenticated,
              options: _ctx.isAuthenticated ? _ctx.userSubjectOptions : _ctx.allSubjectOptions,
              searchable: true,
              "can-clear": false,
              "break-tags": true
            }, null, 8, ["modelValue", "groups", "options"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Editorial, { class: "w-full sm:w-auto" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_Multiselect, {
              id: "input-types",
              modelValue: _ctx.inputTypes,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputTypes) = $event)),
              mode: "tags",
              placeholder: "Select 2 maximum",
              max: 2,
              options: _ctx.typesOptions,
              searchable: true,
              "can-clear": false,
              "break-tags": true
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Editorial, { class: "w-full sm:w-auto mr-4" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_AutoResizeTextarea, {
            id: "input-description",
            modelValue: _ctx.inputDescription,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputDescription) = $event)),
            rows: 2,
            "max-rows": 10,
            class: "input",
            placeholder: "Add at least one sentence and refer to who it is about"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("button", {
          class: "flex items-center text-left w-full sm:w-auto",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleTags && _ctx.toggleTags(...args)))
        }, [
          _createVNode(_component_Editorial, { class: "w-full sm:w-auto mr-4" }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_ArrowUpIcon, {
              class: _normalizeClass(["w-8 h-8 fill-current transition", { 'transform rotate-180': !_ctx.showTags }])
            }, null, 8, ["class"])
          ])
        ]),
        (_ctx.showTags)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.inputTags,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputTags) = $event)),
                mode: "tags",
                "no-options-text": "Type in a tag and press return",
                "no-results-text": "Type in a tag and press return",
                placeholder: "Select or type in search tags ...",
                "close-on-select": false,
                searchable: true,
                "create-option": true,
                options: _ctx.tagsOptions,
                "can-clear": false,
                "break-tags": true
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_AppButton, {
            type: "secondary",
            class: "transition",
            disabled: _ctx.disableClearAllButton,
            onClick: _ctx.handleClearAll
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Clear all ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_AppButton, {
            type: "primary",
            disabled: _ctx.submitIsDisabled,
            "is-loading": _ctx.isLoadingChallenge,
            onClick: _ctx.handleContinue
          }, {
            iconAfter: _withCtx(() => [
              _createVNode(_component_ArrowRightIcon, { class: "ml-2 stroke-current stroke-2" })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Be inspired ")
            ]),
            _: 1
          }, 8, ["disabled", "is-loading", "onClick"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ContentBlockDivider),
    _createVNode(_component_ContentBlock, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Editorial, null, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createBlock(_component_AppButtonRouterLink, {
                key: 0,
                to: { name: 'challenges-saved' },
                type: "text",
                class: "ml-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" View all ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createBlock(_component_ChallengesList, {
              key: 0,
              "is-resolved": false,
              limit: 3
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("p", null, [
                _createTextVNode(" No latest challenges - please "),
                _createElementVNode("button", {
                  class: "text-cebai-primary font-robotoMedium",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleSignUp && _ctx.toggleSignUp(...args)))
                }, " sign up "),
                _createTextVNode(" or "),
                _createElementVNode("button", {
                  class: "text-cebai-primary font-robotoMedium",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleLogin && _ctx.toggleLogin(...args)))
                }, " log in "),
                _createTextVNode(" to start saving challenges, sparks & resources ")
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_GuidedTour, { name: "challenge-new" })
  ], 64))
}